import MapDropdown from 'components/MapDropdown';
import MapDropdownItem from 'components/MapDropdown/components/MapDropdownItem';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const BoundaryPopover = ({
    canvasPosition,
    onClose,
    onDelete,
    onRename,
    testId = TEST_ID
}: Props) => {
    const { DELETE, RENAME } = useTranslation();

    const handleRename = () => {
        onRename?.();
        onClose?.();
    };

    const handleDelete = () => {
        onDelete?.();
        onClose?.();
    };

    const { x, y } = canvasPosition;

    return (
        <div
            className={styles.mapBoundaryPopover}
            data-testid={testId}
            onClick={onClose}
            onMouseDown={e => e.stopPropagation()}>
            <div
                style={{
                    left: `${x}px`,
                    top: `${y}px`
                }}
                className={styles.popover}
                onClick={e => e.stopPropagation()}>
                <MapDropdown className={styles.dropdown}>
                    {onRename && (
                        <MapDropdownItem
                            className={styles.optionText}
                            onClick={handleRename}
                            text={RENAME}
                        />
                    )}

                    {onDelete && (
                        <MapDropdownItem
                            className={styles.optionText}
                            onClick={handleDelete}
                            text={DELETE}
                            textClassName={styles.deleteOption}
                        />
                    )}
                </MapDropdown>
            </div>
        </div>
    );
};

export default BoundaryPopover;
